import { RouteType } from "types/RouteType";
import decisionTrackerRoute from "./DecisionTracker/decisionTracker.Route";
import plantOverviewRoute from "./PlantOverview/PlantOverview.Route";

const operationsRoutesList: RouteType[] = [
    plantOverviewRoute,
    decisionTrackerRoute,
];

export default operationsRoutesList;
